// extracted by mini-css-extract-plugin
module.exports = {"vPrimary3":"#4f47d7","label":"Switch_label__1jlbu","switch":"Switch_switch__2qnHj","input":"Switch_input__2Wak4"};